module.exports = __webpack_public_path__ + "img/homepage-title-cs.4065a4b.svg";